import { useRefreshStore } from "@/common/composables/refreshStore";
import { defineStore } from "pinia";
import { useListReleaseNoteApi } from "../api/listReleaseNoteApi";
import { useReleaseNoteStore } from 'shared/releaseNotes/stores/releaseNoteStore';

export const useRefreshReleaseNoteStore = defineStore('refresh-release-note', () => {

  const listReleaseNoteApi = useListReleaseNoteApi();
  const store = useReleaseNoteStore();

  return useRefreshStore({
    fetchFromServer() {
      return listReleaseNoteApi.execute();
    },
    mergeToStore(response) {
      store.merge(response.notes);
    },
  })
});
